import Tippy from '@tippyjs/react';
import { ReactElement, ReactNode } from 'react';
import 'tippy.js/dist/tippy.css';
import './styles.scss';

interface TippyViewProps {
    children?: ReactElement;
    visible?: boolean;
    content: ReactNode;
    placement?: any;
    className?: string;
    interactive?: boolean;
    onClickOutside?: () => void;
    // DEV-919: tippy.js writes max-width inline on .tippy-box, so a value set from styles.scss
    // would lose to the inline style without !important. Leaving this undefined keeps tippy's own
    // 350px default - tippy strips undefined props before merging them over its defaults.
    maxWidth?: number | string;
    // DEV-919: tippy.js writes z-index inline on the [data-tippy-root] wrapper, which is not the
    // element `className` lands on, so this is likewise unreachable from CSS.
    zIndex?: number;
}

export const TippyView = ({
    children,
    visible,
    content,
    placement,
    className,
    interactive,
    onClickOutside,
    maxWidth,
    zIndex = 1000
}: TippyViewProps) => {
    return (
        <Tippy
            visible={visible}
            content={content}
            placement={placement}
            className={className}
            interactive={interactive}
            onClickOutside={onClickOutside}
            maxWidth={maxWidth}
            zIndex={zIndex}
        >
            {children}
        </Tippy>
    );
};
